import React, { useMemo } from 'react'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTranslation } from 'react-i18next'

import PageTitle from 'components/atoms/PageTitle'
import IconButton from 'components/atoms/IconButton'

export default function CarDetailsPageTitle({
  setShowDetails,
  label,
  cars = [],
  plate,
  activeCarKey,
  getCarKey = (car) => car?.plate,
  getShowDetailsValue = (car) => car?.plate,
}) {
  const { t } = useTranslation()

  const resolvedActiveCarKey = useMemo(
    () => activeCarKey || plate,
    [activeCarKey, plate]
  )

  const currentIndex = useMemo(
    () => cars.findIndex((car) => getCarKey(car) === resolvedActiveCarKey),
    [cars, getCarKey, resolvedActiveCarKey]
  )

  const next = useMemo(
    () =>
      currentIndex >= 0 && currentIndex < cars.length - 1
        ? cars[currentIndex + 1]
        : null,
    [cars, currentIndex]
  )

  const previous = useMemo(
    () => (currentIndex > 0 ? cars[currentIndex - 1] : null),
    [cars, currentIndex]
  )

  return (
    <Box display="flex" direction="row" justifyContent="space-between">
      <PageTitle
        label={
          <Stack direction="row" alignItems="center">
            <IconButton onClick={() => setShowDetails(false)}>
              <ChevronLeftIcon />
            </IconButton>
            <Box mr={2} />
            <Typography variant="h4">
              <strong>{label || t('carDetails.title')}</strong>
            </Typography>
          </Stack>
        }
      />
      <Stack direction="row" alignItems="center">
        {previous && (
          <IconButton
            onClick={() => setShowDetails(getShowDetailsValue(previous))}
          >
            <ChevronLeftIcon />
          </IconButton>
        )}
        {previous && next && <Box pr={1} />}
        {next && (
          <IconButton onClick={() => setShowDetails(getShowDetailsValue(next))}>
            <ChevronRightIcon />
          </IconButton>
        )}
      </Stack>
    </Box>
  )
}

CarDetailsPageTitle.propTypes = {
  label: T.string,
  linkTo: T.string,
  activeCarKey: T.string,
  getCarKey: T.func,
  getShowDetailsValue: T.func,
}
